import { counterId } from '../YandexMetrika.constants'

declare const ym: (counterId: string, type: string, goalName: string) => void

export const useYandexMetrika = () => {
  const reachGoal = (goalName: string) => {
    if (typeof window !== 'undefined' && typeof ym === 'function') {
      ym(counterId, 'reachGoal', goalName)
    }
  }

  return { reachGoal }
}
